import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { UserLevel } from '@infuse/iam/user/type';

export const useRouteLevel = () => {
  const route = useRoute();
  const routeName = computed(() => route.name?.toString());

  const level = computed(() => {
    if (routeName.value?.includes('tenant')) {
      return UserLevel.TENANT;
    } else if (routeName.value?.includes('organisation')) {
      return UserLevel.ORGANISATION;
    }

    return UserLevel.DOMAIN;
  });

  const parentId = computed(() => {
    if (routeName.value?.includes('tenant') || routeName.value?.includes('organisation')) {
      return route.params.id.toString();
    }

    return undefined;
  });

  return {
    level,
    parentId
  };
};
